import axios from 'axios';

export async function getMessage() {
  const response = await axios.get('/api/hello');
  return response.data;
}